import { createRef, useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import logoEcole229 from "../../../assets/images/logo.jpg";
import Authentification from "../../../api/Authentification";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { routes } from "../../../routes";

const ResetPassword = () => {
  const recaptchaRef = createRef();
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [iconPassword, setIconPassword] = useState(false);
  const [typeFieldPassword, setTypeFieldPassword] = useState(false);
  const navigate = useNavigate();

  const schema = Yup.object({
    password: Yup.string()
      .required("Le mot de passe est obligatoire")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&-+=()!]).{8,24}$/,
        { message: "Mot de passe trop faible" }
      ),
    password_confirmation: Yup.string()
      .required("Confirmez le mot de passe")
      .oneOf([Yup.ref("password"), null], "Mot de passe différent"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const handleCLickIconPasswords = (e) => {
    e.preventDefault();
    setIconPassword(!iconPassword);
    setTypeFieldPassword(!typeFieldPassword);
  };

  useEffect(() => {
    const access_token = params.token;
    localStorage.setItem("access_token", JSON.stringify(access_token));
  }, [params]);

  const changeCredential = (data) => {
    setLoading(true);
    const recaptchaValue = recaptchaRef.current.getValue();
    if (recaptchaValue) {
      data.fresh = true;
      Authentification.changePassword(data)
        .then((res) => {
          setLoading(false);
          if (res.data.error) {
            toast.current.show({
              severity: "error",
              summary: "Ereur",
              detail: "Erreur de validation",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail: "Mot de passe modifié avec succès",
              life: 3000,
            });
            setTimeout(() => {
              localStorage.removeItem("access_token");
              navigate(routes.auth + routes.login);
            }, 3000);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Erreur de validation",
            life: 3000,
          });
        });
    } else {
      setLoading(false);
      toast.current.show({
        severity: "warn",
        summary: "Avertissement",
        detail: "Veuillez valider le captcha svp !",
        life: 3000,
      });
    }
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="auth__logo">
        <img src={logoEcole229} alt="logo_ecole229" />
      </div>
      <p className="mb-5 subtitle text-center">
        Veuillez créer un nouveau mot de passe !
      </p>
      <div className="auth__form">
        <form className="form" onSubmit={handleSubmit(changeCredential)}>
          <div className="form__item">
            <label htmlFor="password">Nouveau mot de passe</label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password"
                label="password"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <a
                href="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </a>
            </div>
            <ErrorMsg>{errors.password?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <label htmlFor="password_confirmation">
              Confirmer nouveau mot de passe
            </label>
            <div className="form__item__ic_p">
              <TextInput
                type={typeFieldPassword ? "text" : "password"}
                name="password_confirmation"
                label="password_confirmation"
                register={register}
              />
              <i className="pi pi-lock"></i>
              <Link
                to="#"
                className="password-ic"
                onClick={handleCLickIconPasswords}
              >
                <i
                  className={`pi ${iconPassword ? "pi-eye" : "pi-eye-slash"}`}
                ></i>
              </Link>
            </div>
            <ErrorMsg>{errors.password_confirmation?.message}</ErrorMsg>
          </div>
          <div className="form__item">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              ref={recaptchaRef}
            />
          </div>
          <div className="form__item">
            <button type="submit">
              Changer le mot de passe{" "}
              <ProgressSpinner
                style={
                  loading
                    ? { width: "20px", height: "20px" }
                    : { width: "0px", height: "0px" }
                }
                strokeWidth="8"
                loading={loading}
              />
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
